<template>
	<div>
		<van-nav-bar :title="title" :left-arrow="back" @click-left="toBack"></van-nav-bar>
	</div>
</template>

<script>
	export default {
		name: 'Nav',
		props:{
			title:{
				type:String,
				default:''
			},
			back:{
				type:Boolean,
				default:true
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
		  toBack() {
		    this.$router.go(-1);
		  },
		},
	}
</script>

<style scoped>
</style>
